module.exports = __webpack_public_path__ + "static/media/S (100).120a9c68.jpg";